// extracted by mini-css-extract-plugin
export default {"header_gl":"termsgl_header_gl__qmU6I","card_gl":"termsgl_card_gl__mNB8F"};